// import React, { useEffect } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import { useNavigate } from "react-router-dom";

// const API_URL = process.env.REACT_APP_API_URL;

// const PaymentSuccess = () => {
//   const navigate = useNavigate();

//   useEffect(() => {
//     const verifyPayment = async () => {
//       const orderId = new URLSearchParams(window.location.search).get("order_id");

//       if (!orderId) return;

//       try {
//         const res = await axios.get(`${API_URL}/payment/verify/${orderId}`);

//         if (res.data.success) {
//           Swal.fire({
//             icon: "success",
//             title: "Payment Successful!",
//             text: "Redirecting to homepage...",
//             timer: 2000,
//             showConfirmButton: false,
//           }).then(() => {
//             localStorage.removeItem("cart");
//             navigate("/");
//           });

//         } else {
//           Swal.fire({
//             icon: "error",
//             title: "Payment Not Completed",
//           }).then(() => {
//             navigate("/");
//           });
//         }

//       } catch (err) {
//         console.log(err);
//       }
//     };

//     verifyPayment();
//   }, [navigate]);

//   return (
//     <div style={{ padding: "50px", textAlign: "center" }}>
//       <h2>Verifying Payment...</h2>
//     </div>
//   );
// };

// export default PaymentSuccess;

import React, { useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL;

const PaymentSuccess = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handlePayment = async () => {
      try {
        const params = new URLSearchParams(window.location.search);
        const orderId = params.get("order_id"); // Cashfree case
        const isStripe = params.get("stripe");

        if (orderId && !isStripe) {
          const res = await axios.get(`${API_URL}/payment/verify/${orderId}`);

          if (res.data.success) {
            Swal.fire({
              icon: "success",
              title: "Payment Successful!",
              timer: 2000,
              showConfirmButton: false,
            }).then(() => {
              localStorage.removeItem("cart");
              navigate("/");
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Payment Not Completed",
            }).then(() => navigate("/"));
          }
        } else {
          const stripeOrderId = localStorage.getItem("stripeOrderId");

          if (!stripeOrderId) {
            Swal.fire({
              icon: "error",
              title: "Order not found",
            }).then(() => navigate("/"));

            return;
          }

          Swal.fire({
            icon: "success",
            title: "Payment Successful!",
            timer: 2000,
            showConfirmButton: false,
          }).then(() => {
            localStorage.removeItem("cart");

            localStorage.removeItem("pendingOrder");

            localStorage.removeItem("stripeOrderId");

            navigate("/");
          });
        }
      } catch (err) {
        console.error(err);
        Swal.fire({
          icon: "error",
          title: "Something went wrong",
        }).then(() => navigate("/"));
      }
    };

    handlePayment();
  }, [navigate]);

  return (
    <div style={{ padding: "50px", textAlign: "center" }}>
      <h2>Processing Payment...</h2>
    </div>
  );
};

export default PaymentSuccess;
